import React, { useEffect, useState } from "react"
import { Spinner, Row, Col, Button, Card, CardBody } from "reactstrap"
import StepStatusProdutoSmall from "../StepStatusProdutoSmall/StepStatusProdutoSmall";
import { insert, update, getRegs, notifyByEmail, getProdutoFinal } from '../../utils/fc/index.js'
import PropTypes from 'prop-types';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import oikosApi from '../../services/oikos'
import qs from 'qs';
import moment from 'moment';

function TimelineProdutoSmall(props) {

    return (
      <>
        <Row style={{marginTop: "5px", maxWidth: '1300px'}}>
          <Col>
            <div>
                <Row className="overflow-visible pt-3" style={{marginBottom: "8px"}}>
                  <Col>
                    <Row className="align-items-center">
                      <Col>
                        <StepStatusProdutoSmall {...props} />
                        {/*
                          projeto={props.projeto}
                          actual={prod.prodStatusActual_id || 0}
                          dataContratual={moment(prod.prod_dtContrato).format('DD/MM/YYYY')}
                          tecResp={prod.prod_responsavelNome}
                          prod_aprovCompliance={prod.prod_aprovCompliance}
                          userOikosId={props.userOikosId}
                          prodStatusAlt_obs={prod.prodStatusAlt_obs}
                          produto={count !== 0 ? prod : props.produto}
                        */}
                      </Col>
                    </Row>
                  </Col>
                </Row>
            </div>
          </Col>
        </Row>
      </>
    );
  }


export default TimelineProdutoSmall;
